import { Injectable } from '@angular/core';
import { RedatwaterService } from './redatwater.service';
import { Preferences } from '@capacitor/preferences';
import { IAuth, IAuthDispositivo } from '../interfaces/book.interface';
import { NavController } from '@ionic/angular';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  authAdmin: IAuth;
  authDispositivo: IAuthDispositivo;

  private authSubject: any;
  private authAdminSubject: any;

  constructor(
    public navCtrl: NavController,
  ) {
    this.authSubject = new BehaviorSubject(this.authDispositivo);
    this.authAdminSubject = new BehaviorSubject(this.authAdmin);
  }

  /* ************************************************************ */
  /* ***** Auth Banco del Agua **** */
  /* ************************************************************ */

  // Lo demas componentes se ponen a la esucha de cambio
  // a través de esté método
  getAuthDispositivoObservable(): Observable<IAuthDispositivo> {
    //console.log('Escuchando metodo sistema.....');
    return this.authSubject.asObservable();
  }

  getAuthAdminObservable(): Observable<IAuthDispositivo> {
    //console.log('Escuchando metodo admin.....');
    return this.authAdminSubject.asObservable();
  }

  // USUARIO
  setAuthAdmin(auth: IAuth) {
    if (auth) {
      this.authAdmin = auth;
    }
  }

  getAuthAdmin() {
    return this.authAdmin;
  }

  // DISPOSITIVO
  setAuthDispositivo(auth: IAuthDispositivo) {
    if (auth) {
      this.authDispositivo = auth;
      this.authSubject.next(this.authDispositivo);
    }
  }

  setUpdateAuthDispositivo(auth: IAuthDispositivo) {
    if (auth) {
      //console.log('Actualizando Login......');
      this.authDispositivo = auth;
      this.authSubject.next(this.authDispositivo);
    }
  }

  getAuthDispositivo() {
    return this.authDispositivo;
  }


  // Iniciar sesion dispositivo
  async setAuthTokenDispositivo(auth: any) {
    if (auth) {
      this.setAuthTokenDispositivoSession(auth); // Almacenar Session
      this.setAuthDispositivo({
        id: auth.id,
        pais_seleccionado: parseInt(auth.pais_seleccionado),
        version: auth.version,
        dispositivo: auth.dispositivo,
        uid_dispositivo: auth.uid_dispositivo,
        token_app: auth.token_app,
        cant_peticiones: auth.cant_peticiones,
        conexion_stop: auth.conexion_stop,
        ultima_conexion: auth.ultima_conexion,
        estado_id: auth.estado_id,
        conexion: auth.conexion,
        createdAt: auth.createdAt,
        UpdatedAt: auth.updatedAt,

        // EXTERNO
        sistema_id: auth.sistema_id,
        sistema_empresa: auth.empresa,
        sistema_empresa_id: auth.empresa_id,
        sistema_modelo_id: auth.modelo_id,
        sistema_modelo: auth.modelo,
        sistema_public_key: auth.public_key,
        sistema_cant_servicios: auth.modelo_cant_servicios,

        usuario_auth: auth.usuario_auth
      });

      return this.getAuthDispositivo();
    }

  }

  // Crear registro token dispositivo session
  async setAuthTokenDispositivoSession(auth: any) {
    if (auth) {
      Preferences.set({
        key: 'app_auth_dispositivo',
        value: JSON.stringify(auth),
      });
      //console.log('Auth dispositivo -> Session almacenada.');

    }
  }

  // Get registro token dispositivo session
  async getAuthTokenDispositivoSession() {
    const appToken = Preferences.get({ key: 'app_auth_dispositivo' });
    if (appToken) {
      return appToken;
    }
  }

  async loadAuthTokenDispositivo(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getAuthTokenDispositivoSession().then((authData: any) => {
        if (authData.value) {
          // console.log("Auth dispositivo -> " + authData.value);
          resolve(JSON.parse(authData.value));
        } else {
          console.log('Seguimiento de errores -> Auth dispositivo token -> ¡Oops! Informacion de sesion.');
          resolve(false);
        }
      }).catch((error: any) => {
        console.log('Auth dispositivo token -> ¡Oops! Informacion. ', error);
        resolve(false);
      });
    });
  }

  async logoutDispositivo() {
    // console.log('Auth dispositivo -> Cerrar sesion.');
    await Preferences.remove({ key: 'app_auth_dispositivo' });

    this.authDispositivo = null;
    this.authAdmin = null;
    this.setAuthAdmin(this.authAdmin);
    this.setAuthDispositivo(this.authDispositivo);
    this.logoutAdmin(); // ADMIN
    this.logoutAppConfig();
    this.navCtrl?.navigateRoot(['/home']);
  }


  // Iniciar sesion usuario
  async setAuthTokenAdmin(auth: any) {
    if (auth) {
      this.setAuthTokenAdminSession(auth); // Almacenar Session
      this.setAuthAdmin({
        id: auth.id,
        usuario: auth.usuario,
        usuario_id: auth.id,
        codigo: auth.codigo,
        logged_in: true

      });

      return this.getAuthAdmin();
    }

  }

  // Crear registro token admin session
  async setAuthTokenAdminSession(auth: any) {
    if (auth) {
      Preferences.set({
        key: 'app_auth_admin',
        value: JSON.stringify(auth),
      });
      // console.log('Auth ADMIN -> Session almacenada.');

    }
  }

  // Get registro token admin session
  async getAuthTokenAdminSession() {
    const appToken = Preferences.get({ key: 'app_auth_admin' });
    if (appToken) {
      return appToken;
    }
  }

  async loadAuthTokenAdmin(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getAuthTokenAdminSession().then((authData: any) => {
        if (authData.value) {
          // console.log("Auth admin -> " + authData.value);
          resolve(JSON.parse(authData.value));
        } else {
          console.log('Seguimiento de errores -> Auth admin token -> ¡Oops! Informacion de sesion.');
          resolve(false);
        }
      }).catch((error: any) => {
        console.log('Auth admin token -> ¡Oops! Informacion. ', error);
        resolve(false);
      });
    });
  }

  async logoutAdmin() {
    // console.log('Auth admin -> Cerrar sesion.');
    await Preferences.remove({ key: 'app_auth_admin' });
    this.authAdmin = null;
    this.authAdminSubject.next(this.authAdmin);
  }

  async appConfig(data: any) {

    let parametros: any = {
      pais: data.pais,
      pais_id: data.id,
      divisa: data.divisa
    }

    this.setAppCofigSession(parametros);
  }

  async setAppCofigSession(app: any) {
    if (app) {
      Preferences.set({
        key: 'app_config_ubicacion',
        value: JSON.stringify(app),
      });
      console.log('App Config -> Session almacenada.');

    }
  }

  async getAppConfigSession() {
    const appConfig = Preferences.get({ key: 'app_config_ubicacion' });
    if (appConfig) {
      return appConfig;
    }
  }


  async loadAppConfig(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getAppConfigSession().then((authApp: any) => {
        if (authApp.value) {
          // console.log("App Config -> " + authApp.value);
          resolve(JSON.parse(authApp.value));
        } else {
          reject('App config -> no hay sesion.');
        }
      }).catch((error: any) => {
        console.log('App config -> Erro al cargar.');
        reject(error);
      });
    });
  }

  async logoutAppConfig() {
    await Preferences.remove({ key: 'app_config_ubicacion' });
  }

}
